import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { IsNotEmpty, IsNumber, IsOptional, IsString, IsUUID } from 'class-validator'

export class TeachingStaffDto {
  @ApiProperty({
    description: 'ID unique du staff',
    example: '550e8400-e29b-41d4-a716-446655440000',
    type: 'string',
  })
  @IsNotEmpty()
  @IsUUID('4')
  id!: string

  @ApiProperty({
    description: 'ID de l\'enseignement',
    example: '550e8400-e29b-41d4-a716-446655440000',
    type: 'string',
    format: 'uuid',
  })
  @IsNotEmpty()
  @IsUUID('4')
  teachingId!: string

  @ApiProperty({
    description: 'ID de l\'utilisateur enseignant',
    example: '550e8400-e29b-41d4-a716-446655440000',
    type: 'string',
  })
  @IsNotEmpty()
  @IsUUID('4')
  teacherUserId!: string

  @ApiProperty({
    description: 'ID du rôle',
    example: '550e8400-e29b-41d4-a716-446655440000',
    type: 'string',
  })
  @IsNotEmpty()
  @IsUUID('4')
  roleId!: string

  @ApiPropertyOptional({
    description: 'Part de charge de travail',
    example: 50,
    type: Number,
  })
  @IsOptional()
  @IsNumber()
  workloadShare?: number

  @ApiPropertyOptional({
    description: 'ID de l\'utilisateur qui a créé',
    example: '550e8400-e29b-41d4-a716-446655440000',
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  createdByUserId?: string

  @ApiProperty({
    description: 'Date de création',
    example: '2024-01-01T00:00:00.000Z',
  })
  @IsNotEmpty()
  @IsString()
  createdAt!: Date

  @ApiProperty({
    description: 'Date de mise à jour',
    example: '2024-01-01T00:00:00.000Z',
  })
  @IsNotEmpty()
  @IsString()
  updatedAt!: Date

  @ApiPropertyOptional({
    description: 'Date de suppression',
    example: '2024-01-01T00:00:00.000Z',
  })
  @IsOptional()
  deletedAt?: Date

  @ApiPropertyOptional({
    description: 'ID de l\'utilisateur qui a supprimé',
    example: '550e8400-e29b-41d4-a716-446655440000',
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  deletedByUserId?: string
}